module.exports = __webpack_public_path__ + "img/00028.1f2e4c30.webp";